// // // // src/components/School/SchoolHeader.jsx

// // // import React from "react";

// // // const SchoolHeader = ({ school }) => (
// // //   <header className="bg-white shadow sticky top-0 z-50">
// // //     <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
// // //       <div className="flex items-center gap-4">
// // //         {school.logo && <img src={school.logo} alt="School Logo" className="h-12 w-12" />}
// // //         <div>
// // //           <h1 className="text-xl font-bold">{school.name}</h1>
// // //           <p className="text-sm text-gray-500">{school.city}, {school.state}</p>
// // //         </div>
// // //       </div>
// // //       <div className="hidden md:block text-sm text-gray-600">
// // //         📞 {school.phone}
// // //       </div>
// // //     </div>
// // //   </header>
// // // );

// // // export default SchoolHeader;

// // import React, { useState } from "react";
// // import { useRef, useEffect } from "react";
// // import { FaBars, FaTimes } from "react-icons/fa";

// // const SchoolHeader = ({ school }) => {
// //   const [menuOpen, setMenuOpen] = useState(false);
// //   const [loginOpen, setLoginOpen] = useState(false);

// //   const loginRef = useRef();

// //   const toggleMenu = () => setMenuOpen(!menuOpen);
// //   const toggleLogin = () => setLoginOpen(!loginOpen);

// //   useEffect(() => {
// //     const handleClickOutside = (event) => {
// //       if (loginRef.current && !loginRef.current.contains(event.target)) {
// //         setLoginOpen(false);
// //       }
// //     };
// //     document.addEventListener("mousedown", handleClickOutside);
// //     return () => document.removeEventListener("mousedown", handleClickOutside);
// //   }, []);

// //   return (
// //     <header className="bg-white shadow-md sticky top-0 z-50">
// //       <div className="max-w-7xl mx-auto px-4 md:px-6 py-4 flex items-center justify-between">
// //         {/* Branding */}
// //         <div className="flex items-center gap-4">
// //           {school.logo && (
// //             <img
// //               src={school.logo}
// //               alt="School Logo"
// //               className="h-12 w-12 object-contain rounded-md"
// //             />
// //           )}
// //           <div>
// //             <h1 className="text-xl md:text-2xl font-bold text-gray-800">{school.name}</h1>
// //             <p className="text-sm text-gray-500">
// //               {school.city}, {school.state}
// //             </p>
// //           </div>
// //         </div>

// //         {/* Desktop Nav */}
// //         <nav className="hidden md:flex gap-6 items-center text-sm font-medium text-gray-700">
// //           <a href="/" className="hover:text-blue-600 transition">Home</a>
// //           <a href="#about" className="hover:text-blue-600 transition">About Us</a>
// //           <a href="#notice" className="hover:text-blue-600 transition">Notices</a>
// //           <a href="#news" className="hover:text-blue-600 transition">News & Events</a>
// //           <a href="#contact" className="hover:text-blue-600 transition">Contact</a>

// //           {/* Login Dropdown */}
// //           <div className="relative" ref={loginRef}>
// //             <button
// //               onClick={toggleLogin}
// //               className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
// //             >
// //               Login
// //             </button>
// //             {loginOpen && (
// //               <div className="absolute right-0 mt-2 w-48 bg-white border rounded shadow-lg z-50">
// //                 <a
// //                   href="/login/admin"
// //                   className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
// //                 >
// //                   Admin Login (School Owner)
// //                 </a>
// //                 <a
// //                   href="/login/staff"
// //                   className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
// //                 >
// //                   Staff/Teacher/Student Login/Assistant admins
// //                 </a>
// //               </div>
// //             )}
// //           </div>
// //         </nav>

// //         {/* Mobile Hamburger Icon */}
// //         <div className="md:hidden">
// //           <button onClick={toggleMenu} className="text-gray-700 text-xl">
// //             {menuOpen ? <FaTimes /> : <FaBars />}
// //           </button>
// //         </div>
// //       </div>

// //       {/* Mobile Menu */}
// //       {menuOpen && (
// //         <div className="md:hidden bg-white shadow-md border-t">
// //           <nav className="flex flex-col p-4 gap-3 text-gray-700 text-base font-medium">
// //             <a href="/" className="hover:text-blue-600 transition">Home</a>
// //             <a href="#about" className="hover:text-blue-600 transition">About Us</a>
// //             <a href="#notice" className="hover:text-blue-600 transition">Notices</a>
// //             <a href="#news" className="hover:text-blue-600 transition">News & Events</a>
// //             <a href="#contact" className="hover:text-blue-600 transition">Contact</a>

// //             {/* Login Dropdown in mobile */}
// //             <div className="mt-2">
// //               <p className="text-gray-500 mb-1">Login as:</p>
// //               <a
// //                 href="/login/admin"
// //                 className="block px-2 py-1 rounded hover:bg-gray-100"
// //               >
// //                 Admin (School Owner)
// //               </a>
// //               <a
// //                 href="/login/staff"
// //                 className="block px-2 py-1 rounded hover:bg-gray-100"
// //               >
// //                 Staff / Teacher / Student / Assistant admins
// //               </a>
// //             </div>
// //           </nav>
// //         </div>
// //       )}
// //     </header>
// //   );
// // };

// // export default SchoolHeader;

// // import React, { useState, useRef, useEffect } from "react";
// // import { useNavigate } from "react-router-dom"; // 👈 Import navigate hook
// // import { FaBars, FaTimes } from "react-icons/fa";

// // const SchoolHeader = ({ school }) => {
// //   const [menuOpen, setMenuOpen] = useState(false);
// //   const [loginOpen, setLoginOpen] = useState(false);
// //   const loginRef = useRef();
// //   const navigate = useNavigate(); // 👈 Initialize navigate

// //   const toggleMenu = () => setMenuOpen(!menuOpen);
// //   const toggleLogin = () => setLoginOpen(!loginOpen);

// //   useEffect(() => {
// //     const handleClickOutside = (event) => {
// //       if (loginRef.current && !loginRef.current.contains(event.target)) {
// //         setLoginOpen(false);
// //       }
// //     };
// //     document.addEventListener("mousedown", handleClickOutside);
// //     return () => document.removeEventListener("mousedown", handleClickOutside);
// //   }, []);

// //   const handleLogin = (role) => {
// //     setLoginOpen(false); // close dropdown
// //     navigate(`/loginPage?role=${role}`); // pass role in query param
// //   };

// //   return (
// //     <header className="bg-white shadow-md sticky top-0 z-50">
// //       <div className="max-w-7xl mx-auto px-4 md:px-6 py-4 flex items-center justify-between">
// //         {/* Branding */}
// //         <div className="flex items-center gap-4">
// //           {school.logo && (
// //             <img
// //               src={school.logo}
// //               alt="School Logo"
// //               className="h-12 w-12 object-contain rounded-md"
// //             />
// //           )}
// //           <div>
// //             <h1 className="text-xl md:text-2xl font-bold text-gray-800">{school.name}</h1>
// //             <p className="text-sm text-gray-500">
// //               {school.city}, {school.state}
// //             </p>
// //           </div>
// //         </div>

// //         {/* Desktop Nav */}
// //         <nav className="hidden md:flex gap-6 items-center text-sm font-medium text-gray-700">
// //           <a href="/" className="hover:text-blue-600 transition">Home</a>
// //           <a href="#about" className="hover:text-blue-600 transition">About Us</a>
// //           <a href="#notice" className="hover:text-blue-600 transition">Notices</a>
// //           <a href="#news" className="hover:text-blue-600 transition">News & Events</a>
// //           <a href="#contact" className="hover:text-blue-600 transition">Contact</a>

// //           {/* Login Dropdown */}
// //           <div className="relative" ref={loginRef}>
// //             <button
// //               onClick={toggleLogin}
// //               className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
// //             >
// //               Login
// //             </button>
// //             {loginOpen && (
// //               <div className="absolute right-0 mt-2 w-56 bg-white border rounded shadow-lg z-50">
// //                 <button
// //                   onClick={() => handleLogin("admin")}
// //                   className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
// //                 >
// //                   Admin Login (School Owner)
// //                 </button>
// //                 <button
// //                   onClick={() => handleLogin("staff")}
// //                   className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
// //                 >
// //                   Staff / Teacher / Student / Assistant
// //                 </button>
// //               </div>
// //             )}
// //           </div>
// //         </nav>

// //         {/* Mobile Hamburger Icon */}
// //         <div className="md:hidden">
// //           <button onClick={toggleMenu} className="text-gray-700 text-xl">
// //             {menuOpen ? <FaTimes /> : <FaBars />}
// //           </button>
// //         </div>
// //       </div>

// //       {/* Mobile Menu */}
// //       {menuOpen && (
// //         <div className="md:hidden bg-white shadow-md border-t">
// //           <nav className="flex flex-col p-4 gap-3 text-gray-700 text-base font-medium">
// //             <a href="/" className="hover:text-blue-600 transition">Home</a>
// //             <a href="#about" className="hover:text-blue-600 transition">About Us</a>
// //             <a href="#notice" className="hover:text-blue-600 transition">Notices</a>
// //             <a href="#news" className="hover:text-blue-600 transition">News & Events</a>
// //             <a href="#contact" className="hover:text-blue-600 transition">Contact</a>

// //             {/* Login Options */}
// //             <div className="mt-2">
// //               <p className="text-gray-500 mb-1">Login as:</p>
// //               <button
// //                 onClick={() => handleLogin("admin")}
// //                 className="block text-left w-full px-2 py-1 rounded hover:bg-gray-100"
// //               >
// //                 Admin (School Owner)
// //               </button>
// //               <button
// //                 onClick={() => handleLogin("staff")}
// //                 className="block text-left w-full px-2 py-1 rounded hover:bg-gray-100"
// //               >
// //                 Staff / Teacher / Student / Assistant
// //               </button>
// //             </div>
// //           </nav>
// //         </div>
// //       )}
// //     </header>
// //   );
// // };

// // export default SchoolHeader;


// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { FaBars, FaTimes } from "react-icons/fa";

// const SchoolHeader = ({ school }) => {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const navigate = useNavigate();

//   const toggleMenu = () => setMenuOpen(!menuOpen);

//   const handleLogin = () => {
//     navigate("/loginPage");
//   };

//   return (
//     <header className="bg-white shadow-md sticky top-0 z-50">
//       <div className="max-w-7xl mx-auto px-4 md:px-6 py-4 flex items-center justify-between">
//         {/* Branding */}
//         <div className="flex items-center gap-4">
//           {school.logo && (
//             <img
//               src={school.logo}
//               alt="School Logo"
//               className="h-12 w-12 object-contain rounded-md"
//             />
//           )}
//           <div>
//             <h1 className="text-xl md:text-2xl font-bold text-gray-800">{school.name}</h1>
//             <p className="text-sm text-gray-500">
//               {school.city}, {school.state}
//             </p>
//           </div>
//         </div>

//         {/* Desktop Nav */}
//         <nav className="hidden md:flex gap-6 items-center text-sm font-medium text-gray-700">
//           <a href="/" className="hover:text-blue-600 transition">Home</a>
//           <a href="#about" className="hover:text-blue-600 transition">About Us</a>
//           <a href="#notice" className="hover:text-blue-600 transition">Notices</a>
//           <a href="#news" className="hover:text-blue-600 transition">News & Events</a>
//           <a href="#contact" className="hover:text-blue-600 transition">Contact</a>

//           {/* Direct Login Button */}
//           <button
//             onClick={handleLogin}
//             className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
//           >
//             Login
//           </button>
//         </nav>

//         {/* Mobile Hamburger Icon */}
//         <div className="md:hidden">
//           <button onClick={toggleMenu} className="text-gray-700 text-xl">
//             {menuOpen ? <FaTimes /> : <FaBars />}
//           </button>
//         </div>
//       </div>

//       {/* Mobile Menu */}
//       {menuOpen && (
//         <div className="md:hidden bg-white shadow-md border-t">
//           <nav className="flex flex-col p-4 gap-3 text-gray-700 text-base font-medium">
//             <a href="/" className="hover:text-blue-600 transition">Home</a>
//             <a href="#about" className="hover:text-blue-600 transition">About Us</a>
//             <a href="#notice" className="hover:text-blue-600 transition">Notices</a>
//             <a href="#news" className="hover:text-blue-600 transition">News & Events</a>
//             <a href="#contact" className="hover:text-blue-600 transition">Contact</a>

//             {/* Login Button */}
//             <button
//               onClick={handleLogin}
//               className="mt-2 bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition"
//             >
//               Login
//             </button>
//           </nav>
//         </div>
//       )}
//     </header>
//   );
// };

// export default SchoolHeader;


import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import { useSelector } from "react-redux";

const SchoolHeader = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const { school } = useSelector((state) => state.school);
  const toggleMenu = () => setMenuOpen(!menuOpen);

  console.log(school);
  const handleLogin = () => {
    navigate("/loginPage");
  };

  const handleDashboard = () => {
    if (!user) return;

    switch (user.userType) {
      case "admin":
        navigate("/Admin/dashboard");
        break;
      case "student":
        navigate("/StudentDashboard");
        break;
      case "faculty":
        navigate("/FacultyDashboard");
        break;
      case "staff":
        navigate("/StaffDashboard");
        break;
      case "school":
        navigate("/Adminstrator/dashboard");
        break;
      default:
        alert("Unknown user type");
    }
  };

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-4 flex items-center justify-between">
        {/* Branding */}
        <div className="flex items-center gap-4">
          {school.logo && (
            <img
              src={school.logo}
              alt="School Logo"
              className="h-12 w-12 object-contain rounded-md"
            />
          )}
          <div>
            <h1 className="text-xl md:text-2xl font-bold text-gray-800">{school.name}</h1>
            <p className="text-sm text-gray-500">
              {school.city}, {school.state}
            </p>
          </div>
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex gap-6 items-center text-sm font-medium text-gray-700">
          <a href="/" className="hover:text-blue-600 transition">Home</a>
          <a href="#about" className="hover:text-blue-600 transition">About Us</a>
          <a href="#notice" className="hover:text-blue-600 transition">Notices</a>
          <a href="#news" className="hover:text-blue-600 transition">News & Events</a>
          <a href="#contact" className="hover:text-blue-600 transition">Contact</a>

          {/* Dashboard/Login Button */}
          {isAuthenticated && user ? (
            <button
              onClick={handleDashboard}
              className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 transition"
            >
              Dashboard
            </button>
          ) : (
            <button
              onClick={handleLogin}
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
            >
              Login
            </button>
          )}
        </nav>

        {/* Mobile Hamburger Icon */}
        <div className="md:hidden">
          <button onClick={toggleMenu} className="text-gray-700 text-xl">
            {menuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white shadow-md border-t">
          <nav className="flex flex-col p-4 gap-3 text-gray-700 text-base font-medium">
            <a href="/" className="hover:text-blue-600 transition">Home</a>
            <a href="#about" className="hover:text-blue-600 transition">About Us</a>
            <a href="#notice" className="hover:text-blue-600 transition">Notices</a>
            <a href="#news" className="hover:text-blue-600 transition">News & Events</a>
            <a href="#contact" className="hover:text-blue-600 transition">Contact</a>

            {/* Dashboard/Login Button */}
            {isAuthenticated && user ? (
              <button
                onClick={() => {
                  handleDashboard();
                  setMenuOpen(false);
                }}
                className="mt-2 bg-green-600 text-white py-2 rounded hover:bg-green-700 transition"
              >
                Dashboard
              </button>
            ) : (
              <button
                onClick={() => {
                  handleLogin();
                  setMenuOpen(false);
                }}
                className="mt-2 bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition"
              >
                Login
              </button>
            )}
          </nav>
        </div>
      )}
    </header>
  );
};

export default SchoolHeader;
